/**
 * Validates that the first argument is truthy
 * @param value The object to test if is truthy
 * @returns {boolean} whether the parameter is truthy
 */
export default function isTruthy<T>(value: T): value is Exclude<T, false | undefined | null | 0> {
  return Boolean(value);
}
